import { AdminDatasetListResponse } from "admin/types/interfaces/adminDataset";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

/**
 * Page size requested from the admin datasets endpoint. The UI keeps client-side
 * search/sort while the full result set fits in a single page of this size; once
 * the total exceeds it, the UI falls back to server-side sorting and pagination.
 */
export const ADMIN_DATASETS_PAGE_SIZE = 500;

interface UseAdminDatasetsOptions {
  offset?: number;
  limit?: number;
  /** Server sort field, optionally prefixed with '-' for descending (e.g. '-updatedAt'). */
  sort?: string;
}

const useAdminDatasets = ({
  offset = 0,
  limit = ADMIN_DATASETS_PAGE_SIZE,
  sort,
}: UseAdminDatasetsOptions = {}) => {
  let url = `${VITE_CATALOG_API}/admin/datasets?offset=${offset}&limit=${limit}`;
  if (sort) {
    url += `&sort=${encodeURIComponent(sort)}`;
  }

  const { data, error, isLoading, mutate } = useFetcher<AdminDatasetListResponse>(url);

  return {
    items: data?.items ?? [],
    metadata: data?.metadata,
    isLoading,
    error,
    mutate,
  };
};

export default useAdminDatasets;
